(function (root, factory) {
  'use strict';
  const bridge = factory();
  if (typeof module === 'object' && module.exports) module.exports = bridge;
  else root.FwdMeasurementBridge = bridge;
})(typeof globalThis === 'object' ? globalThis : this, function () {
  'use strict';
  const names = {
    'Session Started': 'FWD Session Started', 'Page Viewed': 'FWD Page Viewed',
    'Product Viewed': 'FWD Product Detail Viewed', 'Product Clicked': 'FWD Product Clicked',
    'Product Exposed': 'FWD Product Exposed', 'Wishlist Item Added': 'FWD Wishlist Item Added',
    'Wishlist Item Removed': 'FWD Wishlist Item Removed', 'Product Filters Applied': 'FWD Filters Applied',
    'Product Sort Changed': 'FWD Sort Applied', 'UI Interaction': 'FWD Component Interacted',
    'Link Clicked': 'FWD Component Interacted', 'Search Submitted': 'FWD Search Submitted',
    'Search Opened': 'FWD Search Opened', 'Search Closed': 'FWD Search Closed',
    'Product Inquiry Opened': 'FWD Product Inquiry Opened', 'Page Engagement': 'FWD Visible Time Segment',
  };
  const fields = [
    'supports_product_click', 'supports_wishlist', 'supports_filters', 'supports_components', 'supports_journeys', 'supports_exposures',
    'page_view_id', 'page_path', 'page_type', 'page_title', 'session_id', 'tab_id', 'list_render_id', 'filter_state_id',
    'product_id', 'variant_id', 'product_name', 'product_category', 'product_category_source',
    'brand_id', 'brand', 'tagged_sizes', 'recommended_sizes', 'size', 'variant_title',
    'unit_price', 'price_currency', 'price_source', 'price_conversion', 'price_basis',
    'filter_state_status', 'filter_tokens', 'filter_labels', 'filter_groups', 'filter_tokens_key', 'filter_state_label',
    'active_brand_ids', 'active_brand_labels', 'active_recommended_sizes', 'active_tagged_sizes', 'active_variant_sizes',
    'price_min', 'price_max', 'active_filter_count', 'active_filters_truncated',
    'component_key', 'component_label', 'component_role', 'placement', 'action', 'result', 'destination_url',
    'list_position', 'list_name', 'collection_handle', 'navigation_status', 'navigation_action',
    'navigation_interaction_id', 'source_page_view_id', 'previous_page_path', 'previous_page_type',
    'navigation_element_key', 'navigation_element_label', 'navigation_source_placement',
    'navigation_source_list_position', 'navigation_source_collection_handle',
    'navigation_source_filter_tokens', 'navigation_source_filter_labels', 'navigation_source_filter_tokens_key',
    'navigation_source_filter_state_label', 'navigation_source_filter_state_status',
    'source_list_render_id', 'source_filter_state_id', 'interaction_id', 'request_id', 'action_id',
    'previous_filter_state_id', 'before_filter_tokens', 'after_filter_tokens', 'change_type', 'applied',
    'result_count', 'sort_value', 'search_query', 'query_length', 'surface',
    'visible_duration_ms', 'visible_duration_capped', 'engagement_segment_id', 'lifecycle_cause',
    'segment_started_at', 'segment_ended_at', 'measurement_clock', 'segment_clock_discontinuity',
  ];
  function project(name, source, metadata) {
    if (!Object.hasOwn(names, name)) return null;
    const result = { event_name: names[name], measurement_version: 3, producer: 'theme_semantics',
      event_id: metadata.event_id, occurred_at: metadata.occurred_at,
      collector_revision: metadata.collector_revision, environment: metadata.environment,
      sequence: metadata.sequence };
    for (const key of fields) if (Object.hasOwn(source, key)) result[key] = source[key];
    result.tab_session_id = result.session_id;
    delete result.session_id;
    if (result.unit_price !== undefined) result.price_unit = 'major';
    result.brand_label = result.brand;
    delete result.brand;
    if (result.interaction_id && !result.action_id) result.action_id = result.interaction_id;
    if (result.navigation_interaction_id) result.navigation_action_id = result.navigation_interaction_id;
    if (result.previous_page_path) result.source_page_path = result.previous_page_path;
    if (result.navigation_element_key) result.source_component_key = result.navigation_element_key;
    if (result.navigation_source_placement) result.source_placement = result.navigation_source_placement;
    if (result.navigation_source_list_position) result.source_position = result.navigation_source_list_position;
    for (const suffix of ['filter_tokens', 'filter_labels', 'filter_tokens_key', 'filter_state_label', 'filter_state_status']) {
      if (Object.hasOwn(result, 'navigation_source_' + suffix)) result['source_' + suffix] = result['navigation_source_' + suffix];
      delete result['navigation_source_' + suffix];
    }
    if (name === 'Product Clicked') {
      result.source_page_path = result.page_path;
      result.source_component_key = result.component_key;
      result.source_placement = result.placement;
      result.source_filter_tokens = result.filter_tokens;
      result.source_filter_labels = result.filter_labels;
      result.source_filter_tokens_key = result.filter_tokens_key;
      result.source_filter_state_label = result.filter_state_label;
    }
    if (name === 'Product Clicked' || name === 'Product Filters Applied') {
      result.analysis_filter_tokens_key = result.filter_tokens_key;
      result.analysis_filter_state_label = result.filter_state_label;
    } else if (name === 'Wishlist Item Added' || name === 'Wishlist Item Removed') {
      if (result.navigation_status === 'matched' && result.source_filter_state_id) {
        result.analysis_filter_tokens_key = result.source_filter_tokens_key;
        result.analysis_filter_state_label = result.source_filter_state_label;
      } else if (result.page_type === 'collection' || result.page_type === 'search') {
        result.analysis_filter_tokens_key = result.filter_tokens_key;
        result.analysis_filter_state_label = result.filter_state_label;
      }
    }
    if (typeof result.destination_url === 'string') {
      try { result.destination_page_path = new URL(result.destination_url).pathname; } catch (_) { /* Drop non-public destination. */ }
      delete result.destination_url;
    }
    if (result.navigation_status === 'matched') result.navigation_status = 'matched_same_tab_action';
    if (name === 'UI Interaction' || name === 'Link Clicked') result.analysis_component_key = result.component_key;
    if (name === 'Product Viewed' && result.navigation_status === 'matched_same_tab_action') {
      result.analysis_component_key = result.source_component_key;
      result.destination_page_path = result.page_path;
    }
    if (name === 'Product Clicked' && source.product_url) {
      try { result.destination_page_path = new URL(source.product_url).pathname; } catch (_) { /* No inferred destination. */ }
    }
    return result;
  }
  return Object.freeze({ project, names });
});
